/**
 * Shared Progress Note color tokens — single source for the mockup coral
 * accent (`ui-designs` ChartPage palette) and the subsection label grey used
 * across the edit form and the locked viewer.
 */
export const PROGRESS_NOTE_CORAL = '#e8624a'
export const SUBSECTION_LABEL_COLOR = '#374151'
export const MONO_FONT = 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace'
